import {type BaseFlagProps, Flag} from 'platform/components';
import {match} from 'ts-pattern';

interface CustomerInsightsOptionalFlagProps {
  flag: BaseFlagProps | null;
}

export function CustomerInsightsOptionalFlag(props: CustomerInsightsOptionalFlagProps) {
  return match(props.flag)
    .with(null, () => null)
    .otherwise((flag) => <Flag {...flag} size="small" />);
}
